import { getImage } from '../../utils/getImage';
import { searchProductByArticle } from '../../hooks/productArticleSearch';
import { type IProduct } from '../../types/IProduct';
import { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import cn from 'classnames';
import './searchBar.css';

interface Props {
  differentClickAction: string;
  onSelectedItem?: (item: IProduct) => void;
  isMobile?: boolean;
  inputRef?: React.RefObject<HTMLInputElement | null>;
}

export const SearchBar: React.FC<Props> = ({
  differentClickAction,
  onSelectedItem,
  // isMobile,
  inputRef
}) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [searchResults, setSearchResults] = useState<IProduct[]>([]);
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();
  const debounceTimer = useRef<NodeJS.Timeout | undefined>(undefined);

  const handleSearch = (value: string): void => {
    setSearchTerm(value);
    clearTimeout(debounceTimer.current);
    debounceTimer.current = setTimeout(() => {
      void searchProducts(value);
    }, 300);
  };

  const searchProducts = async (value: string): Promise<IProduct[]> => {
    const trimmedValue = value.trim();
    if (trimmedValue === '') {
      setSearchResults([]);
      setMenuOpen(false);
      return [];
    }
    try {
      const results = await searchProductByArticle(trimmedValue);
      setSearchResults(results);
      setMenuOpen(results.length > 0);
      return results;
    } catch {
      setSearchResults([]);
      setMenuOpen(false);
      return [];
    }
  };

  const handleItemClick = (productId: number): void => {
    if (differentClickAction === 'headerSearch') {
      void navigate(`/product/${productId}`);
    } else if (differentClickAction === 'modalSearch') {
      const selectedItem = searchResults.find(
        (product) => product.id === productId
      );
      if (selectedItem !== undefined && onSelectedItem !== undefined) {
        onSelectedItem(selectedItem);
      }
    }
    setSearchTerm('');
    setSearchResults([]);
    setMenuOpen(false);
  };

  useEffect(() => {
    if (menuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [menuOpen]);

  return (
    <div className={`search-bar-container`}>
      <div className="input-wrapper">
        <input
          className={'search-bar-input'}
          type="text"
          placeholder="Поиск по артиклю"
          value={searchTerm}
          onChange={(e) => {
            handleSearch(e.target.value);
          }}
          ref={inputRef}
          name="search"
        />
      </div>
      <div className="search-bar-menu-wrapper">
        {searchResults.map((product) => {
          const imageLink = getImage(product.image);
          const isHidden = product.hidden;
          return (
            <div
              key={product.id}
              className={cn('search-bar-item', { hiddenItem: isHidden })}
              onClick={() => {
                handleItemClick(product.id);
              }}
            >
              <img
                src={imageLink}
                alt={product.name ?? 'No Image'}
                className="product-image-search"
              />
              <p className="product-name">{product.name}</p>
              <p className="product-vendor-code">
                <b>{product.vendorCode}</b>
              </p>
            </div>
          );
        })}
      </div>
    </div>
  );
};
